import { render, staticRenderFns } from "./OnboardContact.vue?vue&type=template&id=93a9cb8a"
import script from "./OnboardContact.vue?vue&type=script&lang=ts"
export * from "./OnboardContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports